import request from "@/util/request";

export function statisticsGroupByTime(model) {
    return request({
        url: '/api-admin/statistics/by/time',
        method: 'post',
        data: model
    })
}

export function statisticsIndexByTime(model) {
    return request({
        url: '/api-admin/statistics/index',
        method: 'post',
        data: model
    })
}

export function statisticsGroupByUser(model) {
    return request({
        url: '/api-admin/statistics/by/user',
        method: 'post',
        data: model
    })
}
